import { Grid } from '@material-ui/core';

import { TableHeaderColumns, TopChannels, TopFiles, TopUsers } from '../../types/AppTypes';
import Table from './Table';
import TableTitle from './TableTitle';
import Skeleton from '../ui/Skeleton/Skeleton';

interface PROPS {
  tableClass: string;
  tableHeaderClass: string;
  headerData: TableHeaderColumns[];
  data: TopFiles[] | TopChannels[] | TopUsers[];
  loading: boolean;
  skeletonRows: number[];
  title: string;
}

const TopDataTableWrapper = ({
  tableClass,
  tableHeaderClass,
  headerData,
  data,
  loading,
  skeletonRows,
  title,
}: PROPS): JSX.Element => {
  const tableColumns = headerData.map((item) => item.title);
  return (
    <Grid item xs={12} className={tableClass}>
      <TableTitle title={title} titleClass={tableHeaderClass} csvData={data} csvHeaders={tableColumns} />
      {!loading ? <Table columns={headerData} data={data} title={title}/> : <Skeleton columns={tableColumns} rows={skeletonRows} />}
    </Grid>
  );
};

export default TopDataTableWrapper;
